import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const capabilitiesSoftSkillTypesAdapter = createEntityAdapter({})

const initialState = capabilitiesSoftSkillTypesAdapter.getInitialState()

export const capabilitiesSoftSkillTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCapabilitiesSoftSkillTypes: builder.query({
            query: () => ({
                url: '/capabilitiesSoftSkillTypes/getCapabilitiesSoftSkillTypes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedCapabilitiesSoftSkillTypes = responseData.map(capabilitiesSoftSkillType => {
                    capabilitiesSoftSkillType.id = capabilitiesSoftSkillType._id
                    return capabilitiesSoftSkillType
                })
                return capabilitiesSoftSkillTypesAdapter.setAll(initialState, loadedCapabilitiesSoftSkillTypes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'CapabilitiesSoftSkillType', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'CapabilitiesSoftSkillType', id}))
                    ]
                } else {
                    return [ { type: 'CapabilitiesSoftSkillType', id: 'LIST'}]
                }
            },
        }),
        createNewCapabilitiesSoftSkillType: builder.mutation({
            query: initialCapabilitiesSoftSkillType => ({
                url: '/capabilitiesSoftSkillTypes/createNewCapabilitiesSoftSkillType',
                method: 'POST',
                body: {...initialCapabilitiesSoftSkillType,}
            }),
            invalidatesTags: [
                { type: 'CapabilitiesSoftSkillType', id: "LIST" }
            ] 
        }),
        updateCapabilitiesSoftSkillType: builder.mutation({
            query: initialCapabilitiesSoftSkillType => ({
                url: '/capabilitiesSoftSkillTypes/updateCapabilitiesSoftSkillType',
                method: 'PATCH',
                body: {...initialCapabilitiesSoftSkillType,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'CapabilitiesSoftSkillType', id: arg.id },
                { type: 'CapabilitiesSoftSkillType', id: 'LIST' }
            ],
        }),
        deleteCapabilitiesSoftSkillType: builder.mutation({
            query: ({id}) => ({
                url: '/capabilitiesSoftSkillTypes/deleteCapabilitiesSoftSkillType',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CapabilitiesSoftSkillType', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetCapabilitiesSoftSkillTypesQuery,
    useCreateNewCapabilitiesSoftSkillTypeMutation,
    useUpdateCapabilitiesSoftSkillTypeMutation,
    useDeleteCapabilitiesSoftSkillTypeMutation,
} = capabilitiesSoftSkillTypesApiSlice

// returns the query result object
export const selectCapabilitiesSoftSkillTypeResult = capabilitiesSoftSkillTypesApiSlice.endpoints.getCapabilitiesSoftSkillTypes.select()

// create memoized selector
const selectCapabilitiesSoftSkillTypesData = createSelector(
    selectCapabilitiesSoftSkillTypeResult,
    capabilitiesSoftSkillTypeResult => capabilitiesSoftSkillTypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllCapabilitiesSoftSkillTypes,
    selectById: selectCapabilitiesSoftSkillTypeById,
    selectIds: selectCapabilitiesSoftSkillTypeIds,
} = capabilitiesSoftSkillTypesAdapter.getSelectors(state => selectCapabilitiesSoftSkillTypesData(state) ?? initialState)